import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {wwData$} from '@px/streams/worker-data';
import MarginActiveOrderData = ww.MarginActiveOrderData;
import Msg = ww.Msg;

export const activeOrderCount$ = new BehaviorSubject<string>('');
export const activeOrders$ = new BehaviorSubject<MarginActiveOrder[]>([]);

wwData$.pipe(filter((o: Msg<MarginActiveOrderData>) => o.type === 'margin-orders-active')).subscribe((msg: Msg<MarginActiveOrderData>) => {
  const {count, orders} = msg.data;
  activeOrderCount$.next(count > 0 ? `(${count})` : '');
  activeOrders$.next(orders);
});
